// DS1.7.11
import React from 'react';
import c from 'classnames';
import HexagonLocked16 from './Hexagon/16x16/Locked';
import HexagonUnlocked16 from './Hexagon/16x16/Unlocked';
import HexagonLocked24 from './Hexagon/24x24/Locked';
import HexagonUnlocked24 from './Hexagon/24x24/Unlocked';
import HexagonLocked32 from './Hexagon/32x32/Locked';
import HexagonUnlocked32 from './Hexagon/32x32/Unlocked';
import HexagonLocked40 from './Hexagon/40x40/Locked';
import HexagonUnlocked40 from './Hexagon/40x40/Unlocked';
import Tier16 from './Tier/16x16';
import Tier24 from './Tier/24x24';
import Tier32 from './Tier/32x32';
import Tier40 from './Tier/40x40';
import Commission16 from './Commission/16x16';
import Commission24 from './Commission/24x24';
import Commission32 from './Commission/32x32';
import Commission40 from './Commission/40x40';
import DollarSignIcon from '../../Icons/16x16/DollarSign';
import s from './PromoBadge.scss';
const lockedHexagonSizes = {
    16: HexagonLocked16,
    24: HexagonLocked24,
    32: HexagonLocked32,
    40: HexagonLocked40
};
const unlockedHexagonSizes = {
    16: HexagonUnlocked16,
    24: HexagonUnlocked24,
    32: HexagonUnlocked32,
    40: HexagonUnlocked40
};
const TierIcon = {
    16: Tier16,
    24: Tier24,
    32: Tier32,
    40: Tier40
};
const CommissionIcon = {
    16: Commission16,
    24: Commission24,
    32: Commission32,
    40: Commission40
};
const PromoBadge = ({ badgeType , size , isLocked , className , useSecondaryColor  })=>{
    const BackgroundComponent = isLocked ? lockedHexagonSizes[size] : unlockedHexagonSizes[size];
    const IconComponent = {
        tier: TierIcon[size],
        commission: CommissionIcon[size],
        premium_gallery: DollarSignIcon
    }[badgeType];
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], s[`type-${badgeType}`], isLocked && s['locked'], s[`size-${size}`], className)
    }, /*#__PURE__*/ React.createElement(BackgroundComponent, {
        className: c(s['background'], useSecondaryColor && s['secondary-color'])
    }), /*#__PURE__*/ React.createElement(IconComponent, {
        className: s['icon']
    }));
};
PromoBadge.displayName = 'PromoBadge';
export default PromoBadge;
